// extracted by mini-css-extract-plugin
module.exports = {"active":"CheckboxButton_active__Vdc2Q","inactive":"CheckboxButton_inactive__begJI"};